import { IconButton, Menu, MenuItem, ListItemIcon, Typography } from "@mui/material";
import React, { useState, ReactNode } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import ViewIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import ReorderIcon from "@mui/icons-material/Reorder";
import SendIcon from "@mui/icons-material/Send";
import DownloadIcon from "@mui/icons-material/Download";
import MapIcon from "@mui/icons-material/Map";


interface IGenericAction {
    label: string;
    icon: GENERIC_ICON_NAME;
    onClick: (row: any) => void;
}

interface IGenericActionPickerProps {
    row: any;
    actions: IGenericAction[];
}

export enum GENERIC_ICON_NAME {
    EDIT = 'edit',
    DELETE = 'delete',
    VIEW = 'view',
    BLOCK = 'block',
    CHECK_CIRCLE = 'check_circle',
    REORDER = 'reorder',
    SEND_TO_CONTACT = 'send_to_contact',
    DOWNLOAD_PDF = 'download_pdf',
    MAP = 'map',
}

const GenericActionPicker: React.FC<IGenericActionPickerProps> = ({ row, actions }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const getIcon = (iconName: GENERIC_ICON_NAME) => {
        switch (iconName) {
            case GENERIC_ICON_NAME.EDIT:
                return <EditIcon />;
            case GENERIC_ICON_NAME.DELETE:
                return <DeleteIcon />;
            case GENERIC_ICON_NAME.VIEW:
                return <ViewIcon />;
            case GENERIC_ICON_NAME.BLOCK:
                return <BlockIcon />;
            case GENERIC_ICON_NAME.CHECK_CIRCLE:
                return <CheckCircleIcon />;
            case GENERIC_ICON_NAME.REORDER:
                return <ReorderIcon />;
            case GENERIC_ICON_NAME.SEND_TO_CONTACT:
                return <SendIcon />;
            case GENERIC_ICON_NAME.DOWNLOAD_PDF:
                return <DownloadIcon />;
            case GENERIC_ICON_NAME.MAP:
                return <MapIcon />;
            default:
                return null;
        }
    }

    return (
        <>
            <IconButton onClick={handleMenuOpen} color="primary" title="Options">
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                {actions.map((action, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            action.onClick(row);
                            handleMenuClose(); // Close menu after action
                        }}
                    >
                        <ListItemIcon>{getIcon(action.icon)}</ListItemIcon>
                        <Typography>{action.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default GenericActionPicker;
